import { render, staticRenderFns } from "./CheckDepositFormConfig.vue?vue&type=template&id=93e42fbe&"
import script from "./CheckDepositFormConfig.vue?vue&type=script&lang=js&"
export * from "./CheckDepositFormConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports